module.exports = __webpack_public_path__ + "static/media/guitar-electric.8deab4e5.svg";